import script from "./SideNavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideNavMenu.vue?vue&type=style&index=0&id=0acdc82f&lang=scss"

const __exports__ = script;

export default __exports__